<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400">
            <v-card >
                <v-card-title class="headline" style="color:#FFFD00;background-color:#363636;">Cancel Subscription</v-card-title>
                <div class="ma-4">
                    Are you sure you want to cancel your subscription to Reflex?
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="keep">Don't Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="cancel" :loading="waiting" :disabled="waiting">Cancel Subscription</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'cancel-payment-plan-dialog',
        data: function ()
        {
            return {
                dialog: Boolean(true)
            }
        },
        computed:
        {
            ...mapState('customerBilling',
            {
                paymentInfo: state => state.paymentInfo
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        props:
        {
            forOrg: null
        },
        mounted()
        {
            this.$logEvent(this.$firebaseAnalytics, 'screen_view',
            {
                app_name: 'Web Portal',
                screen_name: `Reflex Web Portal - ${this.$options.name}`,
                app_version: process.env.VUE_APP_VERSION
            });
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('customerBilling', ['SET_PAYMENT_INFO', 'SET_ORG_PAYMENT_INFO']),
            async cancel()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    this.paymentInfo.cancel = true;
                    if (this.forOrg)
                    {
                        await this.SET_ORG_PAYMENT_INFO({orgId: this.forOrg, data: this.paymentInfo})
                    }
                    else
                    {
                        await this.SET_PAYMENT_INFO(this.paymentInfo)
                    }
                    this.WAITING(false);
                    this.$emit('cancel-payment-plan-dialog-response')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message);
                    this.WAITING(false);
                    this.keep(true)
                }
            },
            keep(reload = false)
            {
                this.$emit('cancel-payment-plan-dialog-response', reload)
            }
        }
    };
</script>

<style scoped>
</style>